<mat-card>
  <!-- dialogRef es el MatDialog: cierra igual que tras editar (closeAll) -->
  <app-card-header
    title="Editar Despacho"
    icono="departure_board"
    [botonCerrar]="true"
    (cerrar)="dialogRef.closeAll()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    @if (form && !loading()) {
      <form [formGroup]="form" autocomplete="off">
        <section class="inputs-group">
          <mat-form-field style="width: 100%" subscriptSizing="dynamic">
            <mat-label>Salió</mat-label>
            <input
              matInput
              placeholder="12:15"
              pattern="^(?:[01]\d|2[0-3]):[0-5]\d$"
              formControlName="salio"
            />
            <mat-icon matSuffix>schedule</mat-icon>
          </mat-form-field>
          @if (vehiculos) {
            <ng-select
              [items]="vehiculos"
              bindLabel="identificacion"
              bindValue="_id"
              formControlName="idActivo"
              placeholder="Vehículo"
              [notFoundText]="'No hay vehículos creados'"
              style="width: 100%"
              multiple="false"
              searchable="true"
              appendTo="body"
            ></ng-select>
          }
        </section>

        <section class="inputs-group">
          @if (choferes) {
            <ng-select
              [items]="choferes"
              bindLabel="identificacionInterna"
              bindValue="_id"
              formControlName="idChofer"
              placeholder="Chofer"
              [notFoundText]="'No hay choferes creados'"
              style="width: 100%"
              multiple="false"
              searchable="true"
              appendTo="body"
            ></ng-select>
          }
          @if (recorridos) {
            <ng-select
              [items]="recorridos"
              bindLabel="nombre"
              bindValue="_id"
              formControlName="idsRecorridos"
              placeholder="Recorridos"
              [notFoundText]="'No hay recorridos creados'"
              style="width: 100%"
              multiple="true"
              [closeOnSelect]="false"
              searchable="true"
              appendTo="body"
            ></ng-select>
          }
        </section>

        <section class="inputs-group">
          <mat-checkbox color="primary" formControlName="cancelado">
            Salida cancelada
          </mat-checkbox>
        </section>
      </form>
    }
    @if (loading()) {
      <div class="column-center" style="width: 100%; padding: 24px 0">
        <mat-progress-spinner
          mode="indeterminate"
          diameter="50"
          strokeWidth="5"
        ></mat-progress-spinner>
      </div>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" mat-dialog-close>
      Cancelar
    </button>
    <button
      irxBoton="principal"
      [disabled]="loading()"
      [mat-dialog-close]="true"
      type="button"
      (click)="editar()"
    >
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </mat-card-actions>
</mat-card>
